export const Features = {
  SentryEnabled: 'VITE_APP_SENTRY_ENABLED',
  ReportingV2: 'VITE_APP_REPORTING_V2',
  ReportFilters: 'VITE_APP_SHOW_REPORT_FILTERS',
  IntercomEnabled: 'VITE_APP_ENABLE_INTERCOM',
  DatadogEnabled: 'DATADOG_ENABLED',
  DatadogProxyEnabled: 'DATADOG_PROXY_ENABLED',
  MixpanelEnabled: 'MIXPANEL_ENABLED',
  EnablePasswordlessMagicLinks: 'VITE_APP_ENABLE_PASSWORDLESS_MAGIC_LINKS',
  EnablePasswordlessOtp: 'VITE_APP_ENABLE_PASSWORDLESS_OTP',
  NatteringDisconnectOverlay: 'VITE_APP_NATTERING_DISCONNECT_OVERLAY',
  AblyTechCheckProbe: 'VITE_APP_ABLY_TECH_CHECK_PROBE',
  LiveCaptions: 'VITE_APP_LIVE_CAPTIONS',
  NatalieReporting: 'VITE_APP_NATALIE_REPORTING',
  CustomVideoBackground: 'VITE_APP_CUSTOM_VIDEO_BACKGROUND',
} as const;
